// extracted by mini-css-extract-plugin
module.exports = {"keyPoints":"WhySellAtCatawiki_keyPoints__wBslR","keyPointsBlock":"WhySellAtCatawiki_keyPointsBlock__6NuMB","imageWrapper":"WhySellAtCatawiki_imageWrapper__6isZd"};